import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import axios from 'axios'
import App from './App'

// La zona horaria del equipo es lo que delata a quien usa VPN: la VPN cambia por
// dónde sale el tráfico, no la configuración del sistema. El backend compara este
// valor contra el país de la IP.
//
// Va como parámetro de consulta y no como header a propósito: un header propio
// obliga al navegador a pedir permiso antes (preflight), y la config de CORS de
// nginx no lo autoriza, lo que tumbaría todas las llamadas a la API.
const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

// De dónde vino la visita (buscador, red social, link externo) solo se puede leer
// del navegador en la carga inicial de la página — document.referrer se pierde en
// cuanto el usuario navega dentro de la SPA. Se guarda en sessionStorage la primera
// vez para que sobreviva esa navegación interna (y un F5 en cualquier ruta), y se
// manda en cada request como parámetro, igual que client_tz y por la misma razón:
// un header propio dispara preflight y la config de CORS de nginx no lo permite.
let landingData = {}
try {
  const stored = sessionStorage.getItem('yp_landing_data')
  if (stored) {
    landingData = JSON.parse(stored)
  } else {
    const params = new URLSearchParams(window.location.search)
    landingData = {
      referrer: document.referrer || '',
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
    }
    sessionStorage.setItem('yp_landing_data', JSON.stringify(landingData))
  }
} catch (e) {
  // Si sessionStorage no está disponible, seguimos sin esta métrica.
}

axios.interceptors.request.use((request) => {
  request.params = { ...request.params, client_tz: clientTimezone, ...landingData }
  return request
})

// Un cliente logueado puede prender la VPN (o quedar en un país bloqueado) en
// cualquier momento de la sesión, no solo al cargar la página — AccessGate ya
// solo chequea una vez al montar. Cualquier 403 de bloqueo geográfico, venga
// de donde venga, dispara este evento para que AccessGate muestre la pantalla
// completa en el momento, en vez de que cada pantalla se las arregle con un
// listado vacío que no explica nada ("No hay modelos para mostrar").
const BLOCK_CODES = ['vpn_detected', 'country_blocked', 'country_blocked_timezone', 'location_unverifiable']

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const code = error.response?.data?.code
    if (error.response?.status === 403 && BLOCK_CODES.includes(code)) {
      window.dispatchEvent(new CustomEvent('yp:access-blocked', { detail: error.response.data }))
    }
    return Promise.reject(error)
  },
)

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App></App>
  </StrictMode>,
)
